<template>
  <div class="supplier-com" :style="style" @click="goProductStore">
    <div class="supplier-top">
      <div class="supplier-top-info flex p-14">
        <img class="w-64 h-64 rounded-full"
          :src="supplier.logoUrl"
        />
        <div class="supplier-info ml-8">
          <div class="supplier-name text-base font-bold text-left">
            {{supplier.name}}
          </div>
          <div class="supplier-address w-180 truncate text-left">
            {{supplier.address}}
          </div>
        </div>
      </div>
      <div class="supplier-profile">
        <div class="supplier-profile-cell flex items-center">
          <div class="supplier-bd"></div><div class="sup-pro-cnt">{{tagString||'暂无分类'}}</div>
        </div>
        <div class="supplier-profile-cell flex items-center">
          <div class="supplier-bd"></div><div class="sup-pro-cnt">{{reportType||'暂无资质'}}</div>
        </div>
        <div class="supplier-profile-cell flex items-center">
          <div class="supplier-bd"></div><div class="sup-pro-cnt">食品检测报告</div>
        </div>
      </div>
      <div class="supplier-buy-btn mb-14 ml-14 align-center">供应商详情</div>
    </div>
  </div>
  
</template>
<script setup>
import { message } from "ant-design-vue";
import { ref, computed } from "vue";
import { useRouter } from 'vue-router'
const router = useRouter()
const enumType = {
  'PRODUCTION_IMG': '生产环境',
  'FOOD_SAFETY': '食品安全',
  'EXAMINING_REPORT': '检测报告',
  'CERTIFICATION': '合格证',
  'NUTRITIVE_INDEX': '营养指标',
  'CHEF': '厨师',
  'DELIVERY': '配送员',
  'QUALIFICATION': '门店资质',

}
const props = defineProps({
  supplier:{
    require: true,
    type: Object,
    default: ()=>{}
  },
  style:{
    require: false,
  }
})
// mounted() {
//   console.log(props.supplier)
// },
const tagString = computed(()=>props?.supplier?.categoryList?.join('、')||'')
const reportType  = computed(()=>{
  let typeArr = []
  props?.supplier?.qualificationList?.map(key=>{
    typeArr.push(enumType[key.type])
  })
  return Array.from(new Set(typeArr)).join('、')||''
})
// 去店铺
function goProductStore(){
  if(!tagString.value){
    message.warning('该供应商暂无商品')
    return
  }
  router.push('/main/store/detail?id='+props.supplier.id)
}
</script>
<style lang="scss" scoped>
@import "./style/supplierCom.scss";
</style>
